import * as types from '../actions/actionTypes';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export function consents(state = initialState.consents, action) {
    switch (action.type) {
        case types.LOAD_CONSENT_SUCCESS:
            //var myarray = Object.assign({}, action.customers);
            //dont user Object since it will build an object and not an array, just passback the new array for state
            //assignment.
            return action.consents.slice(0);
        case types.DELETE_CONSENT_SUCCESS:
            return action.consents.slice(0);
        case types.UPDATE_CONSENT_SUCCESS:
            return action.consents.slice(0);
        case types.ADD_CONSENT_SUCCESS:
            return action.consents.slice(0);
        default:
            return state;
    }
}
//Special reducer to handler just a single customer value from a read for updating
export function consent(state=initialState.consent,action) {
    switch (action.type) {
        case types.READ_CONSENT_SUCCESS:
            //This is actually an object and not an array so we can do a deep copy and return it for state assignment
            return Object.assign({}, action.consent);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/consentReducer.js